import { render, staticRenderFns } from "./SelectorAndList.vue?vue&type=template&id=8c4619cc&scoped=true&"
import script from "./SelectorAndList.vue?vue&type=script&lang=ts&"
export * from "./SelectorAndList.vue?vue&type=script&lang=ts&"
import style0 from "./SelectorAndList.vue?vue&type=style&index=0&id=8c4619cc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4619cc",
  null
  
)

export default component.exports